import { baseArkhaleAPI } from './base-api'
import { NotificationDispatch } from '../../shared/models/notification.model'

const notificationDispatchApi = baseArkhaleAPI.injectEndpoints({
  endpoints: (build) => {
    return {
      addNotificationDispatch: build.mutation<
        NotificationDispatch,
        Partial<NotificationDispatch>
      >({
        query: (arg) => ({
          url: '/notifications/dispatches',
          method: 'POST',
          body: arg,
        }),
      }),
    }
  },
})

export const { useAddNotificationDispatchMutation } = notificationDispatchApi
